// The redesigned package grid: featured cards (with artwork) 3-across, then a
// compact text-only "Other packages" row. Rendered by every page that honours
// the admin's "Use new package layout?" checkbox (packages.use_new_layout) --
// the elementary OptionSelection page and the shared PackageChooser the
// senior builder uses -- so the two audiences draw the same layout from the
// same code. Which card goes where is partitionPackageGrid's decision.
//
// The grid supplies what comes off the option itself (the option, its price
// for this school, its item list); `cardProps(option)` is the caller's, for
// what the page owns (selection handler, offer, pose state).

import React from 'react';
import PropTypes from 'prop-types';
import PackageDisplayV2 from './PackageDisplayV2';
import partitionPackageGrid from './packageGridLayout';
import styles from './V2Grid.module.sass';

export default function V2Grid({ options, cardProps }) {
  const { featured, extras } = partitionPackageGrid(options);
  // Options arrive with prices already scoped to the school, so the first
  // row IS this school's price (the card reads `price.price`).
  const card = (option, compact) => (
    <PackageDisplayV2
      key={option.id}
      option={option}
      price={option.prices?.[0]}
      imageTypes={option.imageTypes}
      {...cardProps(option)}
      compact={compact}
    />
  );

  return (
    <>
      {featured.length > 0 && (
        <div className={styles.v2Grid}>
          {featured.map((option) => card(option, false))}
        </div>
      )}
      {extras.length > 0 && (
        <>
          {/* "Other" only means something under a featured row; with no
              artwork anywhere the compact cards ARE the packages. */}
          {featured.length > 0 && <h2 className={styles.v2ExtrasHeading}>Other packages</h2>}
          <div className={styles.v2ExtrasRow}>
            {extras.map((option) => card(option, true))}
          </div>
        </>
      )}
    </>
  );
}

V2Grid.propTypes = {
  // Spraypaint Option models, already filtered and ordered by the caller.
  // eslint-disable-next-line react/forbid-prop-types
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  // (option) => the PAGE-owned props for that option's card (selection
  // handler, offer, pose state). option/price/imageTypes are the grid's.
  cardProps: PropTypes.func.isRequired,
};
